<template>
  <header>
    <section class="header_section fix_width">
      <div class="logo">
        <router-link :to="{ name: 'about' }">
          <img src="@/assets/logo.png">
        </router-link>
      </div>
      <navBar />
    </section>
    <router-view name="title"/>
  </header>
</template>

<script>
import navBar from '@/components/navBar.vue'
export default {
  components: {
    navBar
  }
}
</script>

<style lang="less">
  .header_section{
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    margin-bottom: 1.75em;
    .logo{
      width: 8.67em;
      height: auto;
      img{width: 100%;}
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1050px) {
    .header_section{
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      margin-bottom: 1.8em;
      .logo{
        width: 8em;
        margin: 0 0 0 1.5em;
      }
    }
  }

  @media screen and (max-width: 767.9px) {
    .header_section {
      display: block;
      padding: 1em;
      margin-bottom: 1.5em;
      text-align: left;
      .logo{
        display: inline-block;
        width: 7em;
      }
    }
  }
</style>
